module.exports = __webpack_public_path__ + "img/yelloop.7406e991.svg";